import { FeatureType, Menu, MenuType } from "./menu-item-shared";

export const statisticsMenu: Menu = {
  state: 'statistics',
  name: 'menu.statistics',
  icon: 'stacked_bar_chart',
  type: MenuType.Static,
  requiredFeatures: [FeatureType.Reports],
};
